// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GDnF","colBig":"styles_colBig__3VqGz","colSmall":"styles_colSmall__1y8q7","shopifyNameWrapper":"styles_shopifyNameWrapper__1c4Bi"};